import { QIcon_chevron_right } from '@repo/icons/index'
import classNames from 'classnames'
import { useEffect, useState } from 'react'
import {
  useCafAnalysisComponentDetailListV5,
  useCafAnalysisComponentDetailV5,
} from '../../../../../modules/apis/webview/caf'
import useAppRouter from '../../../../../modules/hooks/common/useAppRouter'
import { n_caf } from '../../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import urls from '../../../../../modules/urls'
import { COLORS } from '../../../../../modules/vars'
import ComplexityIntroSection from '../../analysis/complexity/ComplexityIntroSection'
import { tabListMap } from '../../analysis/complexity/ComplexityTabsSection'
import ThickDivider from '../../common/ThickDivider'
import useMetricDetailSidePopup from '../popup/useMetricDetailSidePopup'
import useMetricSidePopup from '../popup/useMetricSidePopup'

interface Props {
  componentId: number
}
const CAFOverviewComplexity = ({ componentId }: Props) => {
  useMetricSidePopup('Complexity')
  useMetricDetailSidePopup()
  const router = useAppRouter()
  const { t } = useTranslation()
  const { lessonId, tab } = router.query
  const { isLoading } = useCafAnalysisComponentDetailV5(+componentId) // 캐싱
  const { data } = useCafAnalysisComponentDetailListV5(componentId)
  const [selectedMetric, setSelectedMetric] = useState<{ title: string[]; value: string; index: number }>({
    title: [],
    value: null,
    index: -1,
  })

  useEffect(() => {
    router.push(urls.student.newPortal.lessons.reviewDetail.asCafMetric(lessonId, 1, componentId, selectedMetric.value))
  }, [selectedMetric])

  return (
    <div className="w-screen px-[16px] sm:w-[424px] sm:px-0">
      <div className="keep-all min-h-screen break-words bg-white pt-[16px] pb-[40px] text-gray-700">
        <div className="mb-[16px] text-[20px] font-bold text-black">{t(n_caf.highlight_list.complexity1)}</div>
        <ComplexityIntroSection componentId={componentId} />
        <ThickDivider />
        <div className="mb-[16px] mt-[20px] text-[20px] font-bold text-black">{t(n_caf.complexity.metric)}</div>
        {data?.metrics
          ?.map((metric) => tabListMap[metric.metric_tag])
          ?.map((item, i) => (
            <ArrowBox
              key={`metric_${item.value}`}
              title={t(item.title)}
              onClick={
                selectedMetric.value === item.value
                  ? () => setSelectedMetric({ title: [], value: null, index: -1 })
                  : () => setSelectedMetric({ ...item, index: i })
              }
              active={selectedMetric.value === item.value}
            />
          ))}
      </div>
    </div>
  )
}

interface ArrowBoxProps {
  title: string
  onClick: any
  active: boolean
}
const ArrowBox = ({ title, onClick, active }: ArrowBoxProps) => {
  return (
    <div
      className={classNames(
        `mb-[8px] flex min-h-[72px] cursor-pointer items-center rounded-[6px] px-[16px] py-[12px] shadow-sm`,
        active ? 'border-[1.5px] border-purple-500 bg-purple-50' : 'border-[1px] border-gray-200 bg-white'
      )}
      onClick={onClick}
    >
      <div className="flex flex-1 items-center justify-between">
        <div>
          <h3 className={classNames('text-[16px]', active ? 'font-bold text-purple-500' : 'font-normal text-black')}>
            {title}
          </h3>
        </div>
        <div className="flex items-center">
          <QIcon_chevron_right color={COLORS.GRAY500} width={16} height={16} />
        </div>
      </div>
    </div>
  )
}

export default CAFOverviewComplexity
